var render = function render(){var _vm=this,_c=_vm._self._c;return _c('communication-bots',{attrs:{"is-loading":_vm.isLoading,"bots":_vm.config.bots,"trigger-types":_vm.config.triggerTypes,"triggers":_vm.triggers,"raw-config":_vm.config.raw},on:{"upsert-trigger":_vm.onUpsertTrigger,"send-test-message":_vm.onSendTestMessage,"delete-trigger":_vm.onDeleteTrigger,"update-config":_vm.onUpdateConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }